import React from "react";
import { Plane, Hotel, Star, ExternalLink } from "lucide-react";
import { BOOKING_LINKS, HOTEL_LINKS, ACTIVITY_LINKS } from "../../../config/tripPlans";
import { FlightTrackerSection } from "../flights/FlightTrackerSection";

const SERIF = { fontFamily: "'Cormorant Garamond', Georgia, serif" };
const LORA  = { fontFamily: "'Lora', Georgia, serif" };

function LinkCard({ item }) {
  return (
    <a
      href={item.url}
      target="_blank"
      rel="noopener noreferrer"
      className="flex items-center justify-between p-4 bg-[#F9F6F0] border border-[#DCD4C6] hover:border-[#C17F59] transition-colors group"
      style={{ borderRadius: "1px" }}
      data-testid={`booking-link-${item.label.toLowerCase().replace(/\s+/g, "-")}`}
    >
      <div className="flex items-center gap-3">
        <div className="w-9 h-9 flex items-center justify-center text-[#F9F6F0] text-xs font-semibold" style={{ background: item.color, borderRadius: "50%" }}>
          {item.label[0]}
        </div>
        <span className="text-sm text-[#2B2623]" style={LORA}>{item.label}</span>
      </div>
      <ExternalLink size={13} strokeWidth={1.5} className="text-[#9A8F86] group-hover:text-[#C17F59] transition-colors" />
    </a>
  );
}

export function FlightsTab({ trip }) {
  const dest  = trip?.destination || "";
  const from  = trip?.ville_depart || "Paris";
  const dateD = trip?.date_depart || "";
  const dateR = trip?.date_retour || "";
  const tripId = trip?.id;

  return (
    <div className="space-y-6">
      {/* ── Flight Tracker ── */}
      {tripId && (
        <FlightTrackerSection tripId={tripId} defaultDate={dateD} />
      )}

      {/* ── Affiliation header ── */}
      <div className="bg-[#FDF8F3] border border-[#DCD4C6] p-4 rounded-sm">
        <p className="text-sm text-[#8B5E34] font-medium mb-1" style={{ ...SERIF, fontWeight: 600 }}>
          Liens pré-remplis avec votre voyage
        </p>
        <p className="text-xs text-[#9A8F86] italic" style={LORA}>
          Destination : {dest} · Du {dateD} au {dateR}
        </p>
      </div>

      {/* ── Vols ── */}
      <div>
        <h3 className="text-xl mb-3 flex items-center gap-2" style={{ ...SERIF, fontWeight: 600, color: "#2B2623" }}>
          <Plane size={15} strokeWidth={1.5} className="text-[#C17F59]" /> Vols
        </h3>
        <div className="space-y-2">
          {BOOKING_LINKS(dest, from, dateD, dateR).map((l) => <LinkCard key={l.label} item={l} />)}
        </div>
      </div>

      {/* ── Hébergements ── */}
      <div>
        <h3 className="text-xl mb-3 flex items-center gap-2" style={{ ...SERIF, fontWeight: 600, color: "#2B2623" }}>
          <Hotel size={15} strokeWidth={1.5} className="text-[#C17F59]" /> Hébergements
        </h3>
        <div className="space-y-2">
          {HOTEL_LINKS(dest, dateD, dateR).map((l) => <LinkCard key={l.label} item={l} />)}
        </div>
      </div>

      {/* ── Activités ── */}
      <div>
        <h3 className="text-xl mb-3 flex items-center gap-2" style={{ ...SERIF, fontWeight: 600, color: "#2B2623" }}>
          <Star size={15} strokeWidth={1.5} className="text-[#C17F59]" /> Activités
        </h3>
        <div className="space-y-2">
          {ACTIVITY_LINKS(dest).map((l) => <LinkCard key={l.label} item={l} />)}
        </div>
      </div>
    </div>
  );
}
